import { Grid, styled } from "@mui/material";

const DialogTypographyText = styled(Grid)(() => ({
    paddingLeft: "1rem",
    paddingRight: "1rem",
}));

export default DialogTypographyText